import React, { useState, useEffect, useCallback } from 'react';
import { callApi } from './api';

function UserGateManager({ user, ownerId, onFinished }) {
  const [allOwnerGates, setAllOwnerGates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedGateIds, setSelectedGateIds] = useState(new Set());

  const fetchOwnerGates = useCallback(async () => {
    if (!ownerId) {
        // This can happen if an L2 admin is not yet assigned to an owner.
        setError("Kan ikke hente porter: Administratoren er ikke knyttet til en eier.");
        setLoading(false);
        return;
    }
    setLoading(true);
    setError(null);
    try {
      const result = await callApi('listAllGatesForOwnerV2', { ownerId });
      
      const gates = result.gates;
      setAllOwnerGates(gates);

      // Initialize selected gates based on what the user already has access to
      const initialGateIds = new Set(user.customClaims?.gates || []);
      setSelectedGateIds(initialGateIds);

    } catch (err) {
      setError('Kunne ikke hente porter: ' + err.message);
    } finally {
      setLoading(false);
    }
  }, [ownerId, user.customClaims?.gates]);

  useEffect(() => {
    fetchOwnerGates();
  }, [fetchOwnerGates]);

  const handleSelectionChange = (gateId) => {
    setSelectedGateIds(prev => {
      const newSet = new Set(prev);
      if (newSet.has(gateId)) {
        newSet.delete(gateId);
      } else {
        newSet.add(gateId);
      }
      return newSet;
    });
  };

  const handleSave = async () => {
    setLoading(true);
    setError(null);
    
    try {
        const newGateList = Array.from(selectedGateIds);
        await callApi('updateUserV2', { uid: user.uid, gates: newGateList });
        onFinished();
    } catch (err) {
        setError('Feil ved lagring av endringer: ' + err.message);
    } finally {
        setLoading(false);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'var(--background-light)', color: 'var(--text-light)', padding: '20px', borderRadius: '5px', maxWidth: '90%', maxHeight: '90vh', overflowY: 'auto' }}>
        <h4>Administrer tilgang for: {user.displayName}</h4>
        
        {loading && <p>Laster porter...</p>}
        {error && <p style={{ color: 'red' }}>{error}</p>}

        {!loading && !error && (
          <div>
            <p>Velg hvilke porter brukeren skal ha tilgang til:</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {allOwnerGates.map(gate => (
                <div key={gate.id}>
                  <label>
                    <input 
                      type="checkbox" 
                      checked={selectedGateIds.has(gate.id)}
                      onChange={() => handleSelectionChange(gate.id)}
                    />
                    {gate.name} ({gate.id})
                  </label>
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
          <button type="button" onClick={onFinished}>Avbryt</button>
          <button type="button" onClick={handleSave} disabled={loading}>{loading ? 'Lagrer...' : 'Lagre Endringer'}</button>
        </div>
      </div>
    </div>
  );
}

export default UserGateManager;
